export const API_BASE_URL = 'https://api.campusonweb.com/api'
// export const API_BASE_URL = 'http://127.0.0.1:8000/api/'
export const IMG_BASE_URL = 'http://online.campusonweb.com'